import React from 'react';

const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://energyperformancedirect.co.uk/#organization",
    "name": "Energy Performance Direct",
    "alternateName": "EPD",
    "description": "Professional Energy Performance Certificates (EPCs), SAP Calculations, U-Value Calculations, Floor Plans, and Energy Consultancy services in South West England. Operating since 2009.",
    "url": "https://energyperformancedirect.co.uk",
    "logo": "https://energyperformancedirect.co.uk/logo.png",
    "image": "https://energyperformancedirect.co.uk/logo.png",
    "telephone": "+44-1392-980077",
    "email": "info@energyperformancedirect.co.uk",
    "foundingDate": "2009",
    "priceRange": "£120 - £1500",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Exeter",
      "addressLocality": "Exeter",
      "addressRegion": "Devon",
      "postalCode": "EX1",
      "addressCountry": "GB"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "50.7184",
      "longitude": "-3.5339"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Exeter"
      },
      {
        "@type": "City",
        "name": "Plymouth"
      },
      {
        "@type": "City",
        "name": "Bristol"
      },
      {
        "@type": "City",
        "name": "Barnstaple"
      },
      {
        "@type": "City",
        "name": "Torquay"
      },
      {
        "@type": "City",
        "name": "Paignton"
      },
      {
        "@type": "City",
        "name": "Bridgwater"
      },
      {
        "@type": "City",
        "name": "Truro"
      },
      {
        "@type": "City",
        "name": "Redruth"
      },
      {
        "@type": "City",
        "name": "Okehampton"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Devon"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Cornwall"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Somerset"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Dorset"
      }
    ],
    "sameAs": [
      "https://www.freeindex.co.uk/profile(energy-performance-direct)_172212.htm",
      "https://www.google.com/maps"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Energy Assessment Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Domestic Energy Performance Certificate (EPC)",
            "description": "Professional domestic EPC assessments for houses, flats, and residential properties throughout South West England."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Commercial Energy Performance Certificate (EPC)",
            "description": "Commercial EPC assessments for offices, warehouses, retail, and industrial properties across the UK."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "SAP Calculations",
            "description": "Standard Assessment Procedure calculations for new builds, conversions, and extensions to comply with Building Regulations Part L."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "U-Value Calculations",
            "description": "Desktop U-Value calculation service for walls, roofs, and floors to determine thermal performance."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Floor Plans & Lease Plans",
            "description": "Professional measured floor plans for marketing and leasehold purposes."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Energy Consultancy",
            "description": "Expert energy consultancy and advice for domestic and commercial buildings, including MEES compliance."
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "48",
      "bestRating": "5",
      "worstRating": "1"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ]
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default OrganizationSchema;
